import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

interface ITextIconProps extends IConDefaultType {}

function TextIcon({ color, className, size = 24, rotate, flip }: ITextIconProps) {
  const fill = color || EColorMap.gray_0;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.00024 4C3.00024 3.44772 3.44796 3 4.00024 3H12.0005H20.0002C20.5525 3 21.0002 3.44772 21.0002 4V8C21.0002 8.55229 20.5525 9 20.0002 9C19.448 9 19.0002 8.55229 19.0002 8V5H13.0005V20H16.0002C16.5525 20 17.0002 20.4477 17.0002 21C17.0002 21.5523 16.5525 22 16.0002 22H12.0005H8.00024C7.44796 22 7.00024 21.5523 7.00024 21C7.00024 20.4477 7.44796 20 8.00024 20H11.0005V5H5.00024V8C5.00024 8.55229 4.55253 9 4.00024 9C3.44796 9 3.00024 8.55229 3.00024 8V4Z"
          fill={fill}
        />
      </svg>
    </i>
  );
}

export default TextIcon;
